module.exports = __webpack_public_path__ + "static/digital-marketing-831ece1b5bb3d4deb1e707b55e5e60c1.svg";